import "@/App.css";
import { Suspense } from "react";
import { lazyPage as lazy } from "@/lib/lazyPage";
import { PageLoader } from "@/components/PageStates";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { ReasonProvider } from "@/components/ReasonDialog";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { UpdateBanner } from "@/components/UpdateBanner";
import { useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout, { NAV, REPORT_PATH } from "@/components/Layout";
const moduleForPath = (p) => { const n = NAV.filter((x) => x.to !== "/" && p.startsWith(x.to)).sort((a, b) => b.to.length - a.to.length)[0]; return n ? (n.access || n.module) : null; };
import Dashboard from "@/pages/Dashboard";
const IncomingCathode = lazy(() => import("@/pages/IncomingCathode"));
const CathodeIssue = lazy(() => import("@/pages/CathodeIssue"));
const Production = lazy(() => import("@/pages/Production"));
const CathodeStock = lazy(() => import("@/pages/CathodeStock"));
const Reports = lazy(() => import("@/pages/Reports"));
const Admin = lazy(() => import("@/pages/Admin"));
const PimCodebook = lazy(() => import("@/pages/PimCodebook"));
const ExternalScrap = lazy(() => import("@/pages/ExternalScrap"));
const IncomingRod = lazy(() => import("@/pages/IncomingRod"));
const Remelt = lazy(() => import("@/pages/Remelt"));
const ColourCodes = lazy(() => import("@/pages/ColourCodes"));
const CostCentres = lazy(() => import("@/pages/CostCentres"));const PurchaseItems = lazy(() => import("@/pages/PurchaseItems"));
const PurchaseRequisitions = lazy(() => import("@/pages/PurchaseRequisitions"));
const PurchaseDashboard = lazy(() => import("@/pages/PurchaseDashboard"));
const PurchaseOrders = lazy(() => import("@/pages/PurchaseOrders"));
const PurchaseReport = lazy(() => import("@/pages/PurchaseReport"));
const GoodsReceipt = lazy(() => import("@/pages/GoodsReceipt"));
const VendorInvoices = lazy(() => import("@/pages/VendorInvoices"));
const ScrapIssue = lazy(() => import("@/pages/ScrapIssue"));
const SilverIssue = lazy(() => import("@/pages/SilverIssue"));
const ScrapStock = lazy(() => import("@/pages/ScrapStock"));
const RodStock = lazy(() => import("@/pages/RodStock"));
const CoilTrace = lazy(() => import("@/pages/CoilTrace"));
const ExtrusionDashboard = lazy(() => import("@/pages/ExtrusionDashboard"));
const ExtrusionProduction = lazy(() => import("@/pages/ExtrusionProduction"));
const ExtrusionPlan = lazy(() => import("@/pages/ExtrusionPlan"));
const PlanningDashboard = lazy(() => import("@/pages/PlanningDashboard"));
const PlanVsActualReport = lazy(() => import("@/pages/PlanVsActualReport"));
const MachineLoadReport = lazy(() => import("@/pages/MachineLoadReport"));
const UnplannedReport = lazy(() => import("@/pages/UnplannedReport"));
const DrawingProduction = lazy(() => import("@/pages/DrawingProduction"));
const DrawbenchReport = lazy(() => import("@/pages/DrawbenchReport"));
const DrawbenchDashboard = lazy(() => import("@/pages/DrawbenchDashboard"));
const DrawbenchDrums = lazy(() => import("@/pages/DrawbenchDrums"));
const MachineReport = lazy(() => import("@/pages/MachineReport"));
const ExtrusionDowntime = lazy(() => import("@/pages/ExtrusionDowntime"));
const QualityInspections = lazy(() => import("@/pages/QualityInspections"));
const QualitySpecs = lazy(() => import("@/pages/QualitySpecs"));
const QualityDashboard = lazy(() => import("@/pages/QualityDashboard"));
const DowntimeReport = lazy(() => import("@/pages/DowntimeReport"));
const CrmDashboard = lazy(() => import("@/pages/CrmDashboard"));
const CrmLeads = lazy(() => import("@/pages/CrmLeads"));
const CrmActivities = lazy(() => import("@/pages/CrmActivities"));
const CrmQuotes = lazy(() => import("@/pages/CrmQuotes"));
const CrmContacts = lazy(() => import("@/pages/CrmContacts"));
const DieOrder = lazy(() => import("@/pages/DieOrder"));
const DieDashboard = lazy(() => import("@/pages/DieDashboard"));
const DieTemplate = lazy(() => import("@/pages/DieTemplate"));
const DieReceiving = lazy(() => import("@/pages/DieReceiving"));
const DieLife = lazy(() => import("@/pages/DieLife"));
const DieConditionReport = lazy(() => import("@/pages/DieConditionReport"));
const ToolPORegister = lazy(() => import("@/pages/ToolPORegister"));
const Vendors = lazy(() => import("@/pages/Vendors"));
const CopperBooking = lazy(() => import("@/pages/CopperBooking"));
const CopperReceipt = lazy(() => import("@/pages/CopperReceipt"));
const ScrapPurchase = lazy(() => import("@/pages/ScrapPurchase"));
const AllocationReport = lazy(() => import("@/pages/AllocationReport"));
const AdvanceLicense = lazy(() => import("@/pages/AdvanceLicense"));
const LmeData = lazy(() => import("@/pages/LmeData"));
const AdvanceLicenseReport = lazy(() => import("@/pages/AdvanceLicenseReport"));
const RMPricing = lazy(() => import("@/pages/RMPricing"));
const MonthlyStatement = lazy(() => import("@/pages/MonthlyStatement"));
const WorkOrders = lazy(() => import("@/pages/WorkOrders"));
const WorkOrderDashboard = lazy(() => import("@/pages/WorkOrderDashboard"));
const WorkOrderConsolidated = lazy(() => import("@/pages/WorkOrderConsolidated"));
const WorkOrderAgeing = lazy(() => import("@/pages/WorkOrderAgeing"));
const HREmployeeProfile = lazy(() => import("@/pages/HREmployeeProfile"));
const HRMonthEntries = lazy(() => import("@/pages/HRMonthEntries"));
const HRMeals = lazy(() => import("@/pages/HRMeals"));
const HRMuster = lazy(() => import("@/pages/HRMuster"));
const HRConsultantPayroll = lazy(() => import("@/pages/HRConsultantPayroll"));
const HRContractPayroll = lazy(() => import("@/pages/HRContractPayroll"));
const HRContractors = lazy(() => import("@/pages/HRContractors"));
const HRDepartments = lazy(() => import("@/pages/HRDepartments"));
const AdminOverview = lazy(() => import("@/pages/AdminOverview"));
const AdminIssues = lazy(() => import("@/pages/AdminIssues"));
const MyIssues = lazy(() => import("@/pages/MyIssues"));
const MyWork = lazy(() => import("@/pages/MyWork"));
const ApprovalQueue = lazy(() => import("@/pages/ApprovalQueue"));
const HRSkillMatrix = lazy(() => import("@/pages/HRSkillMatrix"));
const HRAdvances = lazy(() => import("@/pages/HRAdvances"));
const HRESILeave = lazy(() => import("@/pages/HRESILeave"));
const WorkOrderView = lazy(() => import("@/pages/WorkOrderView"));
const Customers = lazy(() => import("@/pages/Customers"));
const Dispatch = lazy(() => import("@/pages/Dispatch"));
const DeliveryChallans = lazy(() => import("@/pages/DeliveryChallans"));
const NonReturnableDC = lazy(() => import("@/pages/NonReturnableDC"));
const ManualDC = lazy(() => import("@/pages/ManualDC"));
const SaleOrders = lazy(() => import("@/pages/SaleOrders"));
const NrdcGRN = lazy(() => import("@/pages/NrdcGRN"));
const ReturnablePending = lazy(() => import("@/pages/ReturnablePending"));
const NonJobWorkGRN = lazy(() => import("@/pages/NonJobWorkGRN"));
const HsnCodes = lazy(() => import("@/pages/HsnCodes"));
const JwStock = lazy(() => import("@/pages/JwStock"));
const DispatchSahneyPrices = lazy(() => import("@/pages/DispatchSahneyPrices"));
const SaleItems = lazy(() => import("@/pages/SaleItems"));
const CustomerSaleInvoices = lazy(() => import("@/pages/CustomerSaleInvoices"));
const CustomerPayments = lazy(() => import("@/pages/CustomerPayments"));
const SahneyPricing = lazy(() => import("@/pages/SahneyPricing"));
const CustomerSaleDashboard = lazy(() => import("@/pages/CustomerSaleDashboard"));
const HRDashboard = lazy(() => import("@/pages/HRDashboard"));
const HRAttendance = lazy(() => import("@/pages/HRAttendance"));
const HRPayroll = lazy(() => import("@/pages/HRPayroll"));
const HREmployees = lazy(() => import("@/pages/HREmployees"));
const HRRules = lazy(() => import("@/pages/HRRules"));
const HRBiometric = lazy(() => import("@/pages/HRBiometric"));
const HRLeaveRegister = lazy(() => import("@/pages/HRLeaveRegister"));
const HRLateReport = lazy(() => import("@/pages/HRLateReport"));
const HRShiftReport = lazy(() => import("@/pages/HRShiftReport"));
const HRAttendanceDashboard = lazy(() => import("@/pages/HRAttendanceDashboard"));
const HRPayrollAnalytics = lazy(() => import("@/pages/HRPayrollAnalytics"));
const HRPaidDays = lazy(() => import("@/pages/HRPaidDays"));
const HRLeftEmployees = lazy(() => import("@/pages/HRLeftEmployees"));
const HRIncrements = lazy(() => import("@/pages/HRIncrements"));
const PackingList = lazy(() => import("@/pages/PackingList"));
const ExtPackingList = lazy(() => import("@/pages/ExtPackingList"));
const ExtPackingReceipts = lazy(() => import("@/pages/ExtPackingReceipts"));
const KaptonInward = lazy(() => import("@/pages/KaptonInward"));
const KaptonIssue = lazy(() => import("@/pages/KaptonIssue"));
const KaptonStock = lazy(() => import("@/pages/KaptonStock"));
const KaptonPrice = lazy(() => import("@/pages/KaptonPrice"));
const KaptonDashboard = lazy(() => import("@/pages/KaptonDashboard"));
const KaptonNonMoving = lazy(() => import("@/pages/KaptonNonMoving"));
const KaptonValuation = lazy(() => import("@/pages/KaptonValuation"));
const KaptonFgInward = lazy(() => import("@/pages/KaptonFgInward"));
const KaptonFgStock = lazy(() => import("@/pages/KaptonFgStock"));
const KaptonPackingList = lazy(() => import("@/pages/KaptonPackingList"));
const KaptonWorkOrders = lazy(() => import("@/pages/KaptonWorkOrders"));
const KaptonProductionRegister = lazy(() => import("@/pages/KaptonProductionRegister"));
const FgInward = lazy(() => import("@/pages/FgInward"));
const FgIssue = lazy(() => import("@/pages/FgIssue"));
const FgStock = lazy(() => import("@/pages/FgStock"));
const FgStockCheck = lazy(() => import("@/pages/FgStockCheck"));
const FgBoxStock = lazy(() => import("@/pages/FgBoxStock"));
const BoxDesign = lazy(() => import("@/pages/BoxDesign"));
const BoxNumbers = lazy(() => import("@/pages/BoxNumbers"));
const FgPackingLists = lazy(() => import("@/pages/FgPackingLists"));
const PackingDashboard = lazy(() => import("@/pages/PackingDashboard"));
const InternalIndents = lazy(() => import("@/pages/InternalIndents"));
const IndentGrn = lazy(() => import("@/pages/IndentGrn"));
const JobworkPartReport = lazy(() => import("@/pages/JobworkPartReport"));
const ScrapReconciliation = lazy(() => import("@/pages/ScrapReconciliation"));
const FbcRmStock = lazy(() => import("@/pages/FbcRmStock"));
const SubContractorReport = lazy(() => import("@/pages/SubContractorReport"));
const SubContractorReceipts = lazy(() => import("@/pages/SubContractorReceipts"));
const DcPending = lazy(() => import("@/pages/DcPending"));
const CustomerDetail = lazy(() => import("@/pages/CustomerDetail"));
const FixedAssets = lazy(() => import("@/pages/FixedAssets"));
import { ModuleProvider, useModule } from "@/context/ModuleContext";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-sm text-muted-foreground animate-pulse">Loading workspace…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const ObserverOnly = ({ children }) => {
  const { user } = useAuth();
  if (user?.role !== "observer") return <Navigate to="/" replace />;
  return children;
};

// Old link kept alive: /extrusion/plan?month=… → /planning/plan?month=…
const KeepQueryRedirect = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search || ""}`} replace />;
};

const DATA_ENTRY = {
  upcast: "/incoming-cathode", extrusion: "/extrusion/production", quality: "/extrusion/quality", drawbench: "/drawbench/production", rmpricing: "/copper-booking",
  toolmgmt: "/tools/die-order", workorder: "/work-orders", planning: "/planning/plan", customers: "/customers",
  dispatch: "/dispatch", saleitems: "/sale-items", fbc: "/packing-list", fbcindent: "/fbc/indent", crm: "/crm/leads",
  fixedassets: "/fixed-assets", purchase: "/purchase/requisitions", packing: "/ext-packing/packing-list",
  kapton: "/kapton/inward",
};
const MODULE_ORDER = ["workorder", "planning", "upcast", "extrusion", "quality", "drawbench", "packing", "kapton", "rmpricing", "toolmgmt", "masters", "dispatch", "fbc", "fbcindent", "purchase", "crm", "fixedassets"];

// Dashboards & reports are open to every level ≥ "Dashboard & Reports" unless the module is in hide_dash_modules.
const Analytics = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user?.role === "admin") return children;
  const m = moduleForPath(location.pathname);
  const mods = user?.modules || [];
  const hidden = user?.hide_dash_modules || [];
  const ok = m ? (mods.includes(m) && !hidden.includes(m)) : mods.some((x) => !hidden.includes(x));
  return ok ? children : <Navigate to="/" replace />;
};

// Users holding a module at "Dashboard & Reports only" are bounced from any non-report page of that module to its dashboard.
const DashOnlyGate = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const dash = user?.dashboard_modules || [];
  const hiddenDash = user?.hide_dash_modules || [];
  const m = moduleForPath(location.pathname);
  if (user?.role !== "admin" && m && hiddenDash.includes(m) && REPORT_PATH.test(location.pathname)) return <Navigate to={DATA_ENTRY[m] || "/"} replace />;
  if (user?.role === "admin" || dash.length === 0 || REPORT_PATH.test(location.pathname)) return children;
  if (m && dash.includes(m)) {
    const home = { upcast: "/dashboard", extrusion: "/extrusion", quality: "/extrusion/quality/dashboard", planning: "/planning/dashboard", rmpricing: "/rm-pricing", toolmgmt: "/tools/die-dashboard", workorder: "/work-orders/dashboard", fbc: "/fbc/report", fbcindent: "/fbc/rm-stock", kapton: "/kapton/dashboard", purchase: "/purchase/dashboard", customersale: "/customer-sale/dashboard", hr: "/hr/dashboard" }[m] || "/";
    return <Navigate to={home} replace />;
  }
  return children;
};

const Home = () => {
  const { available, rawAvailable } = useModule();
  const { user } = useAuth();
  const canAnalytics = user?.role === "admin" || (user?.modules || []).some((m) => !(user?.hide_dash_modules || []).includes(m));
  const masterHome = rawAvailable.includes("customers") ? "/customers"
    : rawAvailable.includes("vendors") ? "/vendors"
    : rawAvailable.includes("saleitems") ? "/sale-items" : "/customers";
  if (user?.role !== "admin" && available.length) return <Navigate to="/my-work" replace />;
  if (!canAnalytics) {
    const first = MODULE_ORDER.find((m) => available.includes(m)) || "upcast";
    const dest = first === "masters" ? masterHome : DATA_ENTRY[first];
    return <Navigate to={dest || "/incoming-cathode"} replace />;
  }
  if (user?.role === "admin") return <Navigate to="/overview" replace />;
  if (available.includes("upcast")) return <Dashboard />;
  if (available.includes("extrusion")) return <Navigate to="/extrusion" replace />;
  if (available.includes("quality")) return <Navigate to="/extrusion/quality/dashboard" replace />;
  if (available.includes("planning")) return <Navigate to="/planning/dashboard" replace />;
  if (available.includes("packing")) return <Navigate to="/ext-packing/dashboard" replace />;
  if (available.includes("kapton")) return <Navigate to="/kapton/inward" replace />;
  if (available.includes("rmpricing")) return <Navigate to="/rm-pricing" replace />;
  if (available.includes("workorder")) return <Navigate to="/work-orders/dashboard" replace />;
  if (available.includes("masters")) return <Navigate to={masterHome} replace />;
  if (available.includes("fbc")) return <Navigate to="/packing-list" replace />;
  if (available.includes("fbcindent")) return <Navigate to="/fbc/indent" replace />;
  if (available.includes("crm")) return <Navigate to="/crm" replace />;
  if (available.includes("fixedassets")) return <Navigate to="/fixed-assets" replace />;
  if (available.includes("purchase")) return <Navigate to="/purchase/requisitions" replace />;
  return <Navigate to="/tools/die-dashboard" replace />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <DashOnlyGate><Layout /></DashOnlyGate>
          </Protected>
        }
      >
        <Route index element={<Home />} />
        <Route path="dashboard" element={<Analytics><Dashboard /></Analytics>} />
        <Route path="incoming-cathode" element={<IncomingCathode />} />
        <Route path="cathode-issue" element={<CathodeIssue />} />
        <Route path="scrap-issue" element={<ScrapIssue />} />
        <Route path="silver-issue" element={<SilverIssue />} />
        <Route path="external-scrap" element={<ExternalScrap />} />
        <Route path="incoming-rod" element={<IncomingRod />} />
        <Route path="remelt" element={<Remelt />} />
        <Route path="purchase-items" element={<PurchaseItems />} />
        <Route path="colour-codes" element={<ColourCodes />} />
        <Route path="cost-centres" element={<CostCentres />} />
        <Route path="purchase/requisitions" element={<PurchaseRequisitions />} />
        <Route path="purchase/dashboard" element={<Analytics><PurchaseDashboard /></Analytics>} />
        <Route path="purchase/orders" element={<PurchaseOrders />} />
        <Route path="purchase/report" element={<Analytics><PurchaseReport /></Analytics>} />
        <Route path="purchase/goods-receipt" element={<GoodsReceipt />} />
        <Route path="purchase/vendor-invoices" element={<VendorInvoices />} />
        <Route path="production" element={<Production />} />
        <Route path="cathode-stock" element={<Analytics><CathodeStock /></Analytics>} />
        <Route path="scrap-stock" element={<Analytics><ScrapStock /></Analytics>} />
        <Route path="rod-stock" element={<Analytics><RodStock /></Analytics>} />
        <Route path="coil/:coilNo" element={<CoilTrace />} />
        <Route path="reports" element={<Analytics><Reports /></Analytics>} />
        <Route path="vendors" element={<Vendors />} />
        <Route path="copper-booking" element={<CopperBooking />} />
        <Route path="copper-receipt" element={<CopperReceipt />} />
        <Route path="scrap-purchase" element={<ScrapPurchase />} />
        <Route path="copper-allocation-report" element={<AllocationReport />} />
        <Route path="lme-data" element={<LmeData />} />
        <Route path="advance-license" element={<AdvanceLicense />} />
        <Route path="advance-license-report" element={<AdvanceLicenseReport />} />
        <Route path="rm-pricing" element={<Analytics><RMPricing /></Analytics>} />
        <Route path="rm-pricing/monthly" element={<Analytics><MonthlyStatement /></Analytics>} />
        <Route path="extrusion" element={<Analytics><ExtrusionDashboard /></Analytics>} />
        <Route path="extrusion/production" element={<ExtrusionProduction />} />
        <Route path="extrusion/plan" element={<KeepQueryRedirect to="/planning/plan" />} />
        <Route path="planning/dashboard" element={<Analytics><PlanningDashboard /></Analytics>} />
        <Route path="planning/ageing" element={<WorkOrderAgeing />} />
        <Route path="planning/plan" element={<ExtrusionPlan />} />
        <Route path="planning/report/plan-vs-actual" element={<Analytics><PlanVsActualReport /></Analytics>} />
        <Route path="planning/report/machine-load" element={<Analytics><MachineLoadReport /></Analytics>} />
        <Route path="planning/report/unplanned" element={<Analytics><UnplannedReport /></Analytics>} />
        <Route path="extrusion/drawing" element={<Navigate to="/drawbench/production" replace />} />
        <Route path="drawbench" element={<Analytics><DrawbenchDashboard /></Analytics>} />
        <Route path="drawbench/production" element={<DrawingProduction />} />
        <Route path="drawbench/drums" element={<Analytics><DrawbenchDrums /></Analytics>} />
        <Route path="drawbench/report" element={<Analytics><DrawbenchReport /></Analytics>} />
        <Route path="extrusion/machine-report" element={<Analytics><MachineReport /></Analytics>} />
        <Route path="extrusion/downtime" element={<ExtrusionDowntime />} />
        <Route path="extrusion/quality" element={<QualityInspections />} />
        <Route path="extrusion/quality/specs" element={<QualitySpecs />} />
        <Route path="extrusion/quality/dashboard" element={<QualityDashboard />} />
        <Route path="extrusion/downtime-report" element={<Analytics><DowntimeReport /></Analytics>} />
        <Route path="tools/die-order" element={<DieOrder />} />
        <Route path="tools/die-receiving" element={<DieReceiving />} />
        <Route path="tools/die-dashboard" element={<Analytics><DieDashboard /></Analytics>} />
        <Route path="tools/die-template" element={<DieTemplate />} />
        <Route path="tools/die-life" element={<Analytics><DieLife /></Analytics>} />
        <Route path="tools/die-condition-report" element={<Analytics><DieConditionReport /></Analytics>} />
        <Route path="tools/po-register" element={<ToolPORegister />} />
        <Route path="work-orders" element={<WorkOrders />} />
        <Route path="work-orders/sale-orders" element={<SaleOrders />} />
        <Route path="work-orders/dashboard" element={<Analytics><WorkOrderDashboard /></Analytics>} />
        <Route path="work-orders/view/:wono" element={<WorkOrderView />} />
        <Route path="customers" element={<Customers />} />
        <Route path="customers/:id" element={<CustomerDetail />} />
        <Route path="dispatch" element={<Dispatch />} />
        <Route path="dispatch/delivery-challans" element={<DeliveryChallans />} />
        <Route path="dispatch/non-returnable-dc" element={<NonReturnableDC />} />
        <Route path="dispatch/manual-dc" element={<ManualDC />} />
        <Route path="dispatch/nrdc-grn" element={<NrdcGRN />} />
        <Route path="dispatch/returnable-pending" element={<ReturnablePending />} />
        <Route path="dispatch/non-job-work-grn" element={<NonJobWorkGRN />} />
        <Route path="dispatch/hsn-codes" element={<HsnCodes />} />
        <Route path="dispatch/jw-stock" element={<JwStock />} />
        <Route path="dispatch/sahney-prices" element={<DispatchSahneyPrices />} />
        <Route path="customer-sale/dashboard" element={<CustomerSaleDashboard />} />
        <Route path="customer-sale/invoices" element={<CustomerSaleInvoices />} />
        <Route path="hr/dashboard" element={<HRDashboard />} />
        <Route path="hr/attendance" element={<HRAttendance />} />
        <Route path="hr/payroll" element={<HRPayroll />} />
        <Route path="hr/employees" element={<HREmployees />} />
        <Route path="hr/employees/:id" element={<HREmployeeProfile />} />
        <Route path="hr/left-employees" element={<HRLeftEmployees />} />
        <Route path="hr/month-entries" element={<HRMonthEntries />} />
        <Route path="hr/meals" element={<HRMeals />} />
        <Route path="hr/muster" element={<HRMuster />} />
        <Route path="hr/consultants" element={<HREmployees group="consultants" />} />
        <Route path="hr/consultants/attendance" element={<HRAttendance group="consultants" />} />
        <Route path="hr/consultants/muster" element={<HRMuster group="consultants" />} />
        <Route path="hr/consultants/payroll" element={<HRConsultantPayroll />} />
        <Route path="hr/contract" element={<HREmployees group="contract" />} />
        <Route path="hr/contract/contractors" element={<HRContractors />} />
        <Route path="hr/departments" element={<HRDepartments />} />
        <Route path="hr/contract/attendance" element={<HRAttendance group="contract" />} />
        <Route path="hr/contract/late" element={<HRLateReport group="contract" />} />
        <Route path="hr/contract/meals" element={<HRMeals group="contract" />} />
        <Route path="hr/contract/payroll" element={<HRContractPayroll />} />
        <Route path="overview" element={<AdminOnly><AdminOverview /></AdminOnly>} />
        <Route path="my-work" element={<MyWork />} />
        <Route path="approvals" element={<ApprovalQueue />} />
        <Route path="hr/skills" element={<HRSkillMatrix />} />
        <Route path="hr/advances" element={<HRAdvances />} />
        <Route path="hr/esi-leave" element={<HRESILeave />} />
        <Route path="hr/rules" element={<HRRules />} />
        <Route path="hr/biometric" element={<HRBiometric />} />
        <Route path="hr/leave" element={<HRLeaveRegister />} />
        <Route path="hr/late" element={<HRLateReport />} />
        <Route path="hr/shift-report" element={<HRShiftReport />} />
        <Route path="hr/attendance-dashboard" element={<HRAttendanceDashboard />} />
        <Route path="hr/payroll-analytics" element={<HRPayrollAnalytics />} />
        <Route path="hr/paid-days" element={<HRPaidDays />} />
        <Route path="hr/increments" element={<HRIncrements />} />
        <Route path="customer-sale/payments" element={<CustomerPayments />} />
        <Route path="customer-sale/pricing" element={<SahneyPricing />} />
        <Route path="customer-sale/outstanding" element={<Navigate to="/customer-sale/dashboard" replace />} />
        <Route path="sale-items" element={<SaleItems />} />
        <Route path="packing-list" element={<PackingList />} />
        <Route path="ext-packing/dashboard" element={<PackingDashboard />} />
        <Route path="ext-packing/packing-list" element={<ExtPackingList />} />
        <Route path="ext-packing/receipts" element={<ExtPackingReceipts />} />
        <Route path="ext-packing/scrap-reconciliation" element={<ScrapReconciliation ext />} />
        <Route path="ext-packing/fg-inward" element={<FgInward />} />
        <Route path="ext-packing/fg-issue" element={<FgIssue />} />
        <Route path="ext-packing/fg-stock" element={<FgStock />} />
        <Route path="ext-packing/fg-stock-check" element={<FgStockCheck />} />
        <Route path="ext-packing/fg-box-stock" element={<FgBoxStock />} />
        <Route path="ext-packing/box-design" element={<BoxDesign />} />
        <Route path="ext-packing/box-numbers" element={<BoxNumbers />} />
        <Route path="ext-packing/fg-packing-lists" element={<FgPackingLists />} />
        <Route path="kapton/dashboard" element={<KaptonDashboard />} />
        <Route path="kapton/inward" element={<KaptonInward />} />
        <Route path="kapton/issue" element={<KaptonIssue />} />
        <Route path="kapton/stock" element={<KaptonStock />} />
        <Route path="kapton/non-moving" element={<KaptonNonMoving />} />
        <Route path="kapton/price" element={<KaptonPrice />} />
        <Route path="kapton/valuation" element={<KaptonValuation />} />
        <Route path="kapton/packing/fg-inward" element={<KaptonFgInward />} />
        <Route path="kapton/packing/fg-stock" element={<KaptonFgStock />} />
        <Route path="kapton/packing/packing-list" element={<KaptonPackingList />} />
        <Route path="kapton/production/work-orders" element={<KaptonWorkOrders />} />
        <Route path="kapton/production/register" element={<KaptonProductionRegister />} />
        <Route path="fbc/report" element={<Analytics><SubContractorReport /></Analytics>} />
        <Route path="fbc/indent" element={<InternalIndents mode="fbc" />} />
        <Route path="fbc/indent-grn" element={<IndentGrn />} />
        <Route path="fbc/rm-stock" element={<FbcRmStock />} />
        <Route path="fbc/indent/:id/work-order" element={<WorkOrderView viaIndent />} />
        <Route path="work-orders/indents" element={<InternalIndents mode="ext" />} />
        <Route path="work-orders/consolidated" element={<WorkOrderConsolidated />} />
        <Route path="work-orders/ageing" element={<WorkOrderAgeing />} />
        <Route path="fbc/receipts" element={<SubContractorReceipts />} />
        <Route path="fbc/pending" element={<Analytics><DcPending /></Analytics>} />
        <Route path="fbc/part-report" element={<JobworkPartReport />} />
        <Route path="fbc/scrap-reconciliation" element={<ScrapReconciliation />} />
        <Route path="crm" element={<Analytics><CrmDashboard /></Analytics>} />
        <Route path="crm/leads" element={<CrmLeads />} />
        <Route path="crm/activities" element={<CrmActivities />} />
        <Route path="crm/quotes" element={<CrmQuotes />} />
        <Route path="crm/contacts" element={<CrmContacts />} />
        <Route path="admin" element={<AdminOnly><Admin /></AdminOnly>} />
        <Route path="admin/issues" element={<AdminOnly><AdminIssues /></AdminOnly>} />
        <Route path="my-issues" element={<ObserverOnly><MyIssues /></ObserverOnly>} />
        <Route path="admin/item-codes" element={<AdminOnly><PimCodebook /></AdminOnly>} />
        <Route path="fixed-assets" element={<FixedAssets />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ModuleProvider>
          <ConfirmProvider>
            <ReasonProvider>
              <Suspense fallback={<div className="min-h-screen flex items-center justify-center bg-background"><div className="font-mono text-sm text-muted-foreground animate-pulse">Loading…</div></div>}>
                <AppRouter />
              </Suspense>
            </ReasonProvider>
          </ConfirmProvider>
        </ModuleProvider>
      </BrowserRouter>
      <Toaster />
      <UpdateBanner />
    </div>
  );
}

export default App;
